import * as React from "react";
import { useRecordContext } from "react-admin";
import { Typography } from "@mui/material";
import { fmtDate, fmtDateTime } from "../utils/format";

// Remplace <DateField> de react-admin (locale du navigateur, « 12/19/2025 »)
// par le format FR du back-office : « 31 oct. 2026 » / « 31 oct. 2026 14:30 ».
// Mêmes props utiles : source, label, showTime, emptyText, sortable/sortBy.
export const FrDateField = ({ source, showTime = false, emptyText = "—" }) => {
  const record = useRecordContext();
  const v = source
    ? String(source)
        .split(".")
        .reduce((acc, k) => (acc == null ? acc : acc[k]), record)
    : undefined;
  return (
    <Typography component="span" variant="body2" sx={{ whiteSpace: "nowrap" }}>
      {showTime ? fmtDateTime(v, emptyText) : fmtDate(v, emptyText)}
    </Typography>
  );
};

export default FrDateField;
